import { render, staticRenderFns } from "./PaginaNombreDe.vue?vue&type=template&id=519fb84f&scoped=true&"
import script from "./PaginaNombreDe.vue?vue&type=script&lang=js&"
export * from "./PaginaNombreDe.vue?vue&type=script&lang=js&"
import style0 from "./PaginaNombreDe.vue?vue&type=style&index=0&id=519fb84f&lang=scss&scoped=true&"
import style1 from "./PaginaNombreDe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519fb84f",
  null
  
)

export default component.exports